import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {submit} from 'redux-form';

import {withStyles} from '@material-ui/core/styles/index';
import ContentAddIcon from '@material-ui/icons/Add';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import {createUsuario, deleteUsuario, fetchUsuarios, updateUsuario} from '../actions/usuario';
import UsuarioForm from './UsuarioForm';

const styles = {
    action: {
        margin: '10px',
        position: 'fixed',
        bottom: 0,
        right: 0
    },

    actions: {
        whiteSpace: 'nowrap',
        textAlign: 'right'
    },

    list: {
        marginBottom: 60
    }
};

class Usuario extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dialogTitle: null,
            dialogActions: null,
            dialogOpen: false,
            dialogContent: null
        };
    }

    componentDidMount() {
        this.props.fetchUsuarios();
    }

    handleOpenEditDialog(user, actions) {
        this.setState({dialogTitle: 'Editar'});
        this.setState({dialogOpen: !this.state.dialogOpen});
        this.setState({dialogActions: actions});
        this.setState({dialogContent: <UsuarioForm form="editForm" initialValues={user}/>});
    }

    handleOpenConfirmDialog(user, actions) {
        this.setState({dialogTitle: 'Confirmação'});
        this.setState({dialogOpen: !this.state.dialogOpen});
        this.setState({dialogActions: actions});
        this.setState({dialogContent: `Deseja realmente excluir o login ${user.login}?`});
        this.setState({user: user});
    }

    handleOpenCreateDialog(actions) {
        this.setState({dialogTitle: 'Cadastrar'});
        this.setState({dialogOpen: !this.state.dialogOpen});
        this.setState({dialogActions: actions});
        this.setState({dialogContent: <UsuarioForm form="newForm"/>});
    }

    handleCloseDialog() {
        this.setState({dialogOpen: !this.state.dialogOpen});
    }

    handleCreate() {
        this.props.submitNewForm();
        let form = this.props.newForm;

        if (!form.syncErrors) {
            this.props.createUsuario(form.values);
            this.handleCloseDialog();
        }
    }

    handleDelete() {
        this.props.deleteUsuario(this.state.user.id);
        this.handleCloseDialog();
    }

    handleUpdate() {
        this.props.submitEditForm();
        let form = this.props.editForm;

        if (!form.syncErrors) {
            this.props.updateUsuario(form.values);
            this.handleCloseDialog();
        }
    }

    render() {
        const DIALOG_ACTION_DELETE = [
            <Button key="confirm" onClick={() => this.handleDelete()}>Confirmar</Button>,
            <Button key="cancel" color="primary" onClick={() => this.handleCloseDialog()}>Cancelar</Button>
        ];

        const DIALOG_ACTION_EDIT = [
            <Button key="change" onClick={() => this.handleUpdate()}>Alterar</Button>,
            <Button key="cancel" color="primary" onClick={() => this.handleCloseDialog()}>Cancelar</Button>
        ];

        const DIALOG_ACTION_CREATE = [
            <Button key="create" onClick={() => this.handleCreate()}>Cadastrar</Button>,
            <Button key="cancel" color="primary" onClick={() => this.handleCloseDialog()}>Cancelar</Button>
        ];

        return (
            <Fragment>
                <Table className={this.props.classes.list}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Nome</TableCell>
                            <TableCell>Login</TableCell>
                            <TableCell>Empresa</TableCell>
                            <TableCell/>
                        </TableRow>
                    </TableHead>
                    {this.props.usuarios
                        ? <TableBody>
                            {this.props.usuarios.map(row => (
                                    <TableRow key={row.id}>
                                        <TableCell>{row.id}</TableCell>
                                        <TableCell>{row.nome}</TableCell>
                                        <TableCell>{row.login}</TableCell>
                                        <TableCell>{row.contrato}</TableCell>
                                        <TableCell className={this.props.classes.actions}>
                                            <IconButton
                                                onClick={() => this.handleOpenConfirmDialog(row, DIALOG_ACTION_DELETE)}>
                                                <DeleteIcon/>
                                            </IconButton>
                                            <IconButton onClick={() => this.handleOpenEditDialog(row, DIALOG_ACTION_EDIT)}>
                                                <EditIcon/>
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )
                            )}
                        </TableBody>
                        : null
                    }
                </Table>

                <Button variant="fab" color="primary" onClick={() => this.handleOpenCreateDialog(DIALOG_ACTION_CREATE)}
                        className={this.props.classes.action}>
                    <ContentAddIcon/>
                </Button>

                <Dialog disableBackdropClick disableEscapeKeyDown open={this.state.dialogOpen}
                        aria-labelledby="user-dialog-title">
                    <DialogTitle id="user-dialog-title">{this.state.dialogTitle}</DialogTitle>
                    <DialogContent>{this.state.dialogContent}</DialogContent>
                    <DialogActions>{this.state.dialogActions}</DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        usuarios: state.usuarios.data,
        newForm: state.form.newForm,
        editForm: state.form.editForm
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchUsuarios: () => dispatch(fetchUsuarios()),
        createUsuario: (user) => dispatch(createUsuario(user)),
        deleteUsuario: (id) => dispatch(deleteUsuario(id)),
        updateUsuario: (user) => dispatch(updateUsuario(user)),
        submitNewForm: () => dispatch(submit('newForm')),
        submitEditForm: () => dispatch(submit('editForm'))
    };
};

export default compose(
    withStyles(styles, {name: 'Usuario'}),
    connect(mapStateToProps, mapDispatchToProps)
)(Usuario);



// WEBPACK FOOTER //
// src/components/Usuario.js